<p #text>
  <ng-content></ng-content>
</p>
<button
  *ngIf="expandable"
  class="
    ds-text-primary-blue
    hover:ds-text-primary-blue-70 hover:ds-cursor-pointer
    ds-select-none
  "
  (click)="this.expanded ? this.truncate() : this.expand()"
>
  <ng-container *ngIf="expanded === true">
    <ng-content select="[collapse]"></ng-content>
  </ng-container>
  <ng-container *ngIf="expanded === false">
    <ng-content select="[expand]"></ng-content>
  </ng-container>
</button>
